const CommonErrorMessages = () => {
    return {
        VALID_SERVICE_ERROR: "Please select a valid service for the selected carrier",
        VALID_CARRIER_ERROR: "Please select a valid carrier for the selected POL and POD",
        REQUIRED_FIELD_ERROR: "This field is required",
        INVALID_DATE_ERROR: "Please enter a valid date",
        DUPLICATE_ENTRY_ERROR: "This entry already exists",
        NETWORK_ERROR: "A network error occurred. Please try again.",
        ALL_FIELDS_REQUIRED: "All required fields must be filled out",
        ETD_WEEKDAY_ERROR: "ETD Weekday must be a valid weekday",
        ETA_WEEKDAY_ERROR: "ETA Weekday must be a valid weekday",
        CARGO_AVAIL_WEEKDAY_ERROR: "Cargo Availability at Destination CFS Weekday must be a valid weekday",
    };
};

export default CommonErrorMessages;
